var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoftTeams = function SvgMicrosoftTeams(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5059C9",
    d: "M10.765 6.875h3.616c.342 0 .619.276.619.617v3.288a2.27 2.27 0 0 1-2.274 2.27h-.01a2.27 2.27 0 0 1-2.274-2.27V7.199c0-.179.145-.323.323-.323zm2.445-.65a1.464 1.464 0 1 0-.001-2.925c-.809 0-1.465.655-1.465 1.463 0 .807.656 1.462 1.465 1.462z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B83EB",
    d: "M8.651 6.225a2.114 2.114 0 0 0 2.117-2.112A2.114 2.114 0 0 0 8.65 2a2.114 2.114 0 0 0-2.116 2.112c0 1.167.947 2.113 2.116 2.113zm2.822.65h-5.97a.61.61 0 0 0-.596.625v3.75A3.67 3.67 0 0 0 8.488 15a3.67 3.67 0 0 0 3.582-3.75V7.5a.61.61 0 0 0-.597-.625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.814 6.875v5.255a.6.6 0 0 1-.596.595H5.193a4 4 0 0 1-.287-1.476V7.5a.61.61 0 0 1 .597-.624h3.31z",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.488 6.875v5.58a.6.6 0 0 1-.596.595H5.347a3.2 3.2 0 0 1-.267-.65 4 4 0 0 1-.172-1.15V7.498a.61.61 0 0 1 .596-.624h2.985z",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.488 6.875v4.93a.6.6 0 0 1-.596.595H5.08a4 4 0 0 1-.172-1.15V7.498a.61.61 0 0 1 .596-.624h2.985z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.163 6.875v4.93a.6.6 0 0 1-.596.595H5.079a4 4 0 0 1-.172-1.15V7.498a.61.61 0 0 1 .596-.624z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.814 5.195v1.024q-.08.005-.163.006-.08 0-.163-.006A2.115 2.115 0 0 1 6.593 4.6h1.625a.6.6 0 0 1 .596.594z",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.488 5.52v.699a2.12 2.12 0 0 1-1.79-1.293h1.195a.6.6 0 0 1 .595.594",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.488 5.52v.699a2.12 2.12 0 0 1-1.79-1.293h1.195a.6.6 0 0 1 .595.594",
    opacity: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.163 5.52v.647a2.12 2.12 0 0 1-1.465-1.242h.87a.6.6 0 0 1 .595.595",
    opacity: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#microsoft-teams_svg__a)",
    d: "M1.597 4.925h5.969c.33 0 .597.267.597.596v5.958a.596.596 0 0 1-.597.596h-5.97A.596.596 0 0 1 1 11.479V5.521c0-.33.267-.596.597-.596"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.152 7.193H4.959v3.243h-.76V7.193H3.01v-.63h3.141v.63z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft-teams_svg__a",
    x1: 2.244,
    x2: 6.906,
    y1: 4.46,
    y2: 12.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })))));
};
export default SvgMicrosoftTeams;